import React, { useEffect, useState } from 'react';
import { UseFormRegister, UseFormReset } from 'react-hook-form';
import ReactHtmlParser from 'react-html-parser';

import { transformSource, formatBytes } from '../../../utils/helpers';

import IRules from '../../../interfaces/IRules';
import IInputs from '../../../interfaces/IInputs';
import { ReactComponent as RemoveIcon } from './file-remove.svg';
import './InputFile.sass';

interface Props {
	inputName: 'speakerPhoto';
	label: string;
	required?: boolean;
	register: UseFormRegister<IInputs>;
	reset: UseFormReset<IInputs>;
	rules: IRules;
	placeholder: string;
	bottomText: string;
	file?: string;
}

function InputFile({
	inputName,
	register,
	label,
	required,
	rules,
	placeholder,
	bottomText,
	file,
	reset,
}: Props) {
	const [bgImg, setBgImg] = useState<string>();
	const [imgName, setImgName] = useState<string>();
	const [imgSize, setImgSize] = useState<number>();

	useEffect(() => {
		if (file && file.length !== 0) {
			setBgImg(`url(${URL.createObjectURL(file[0])})`);
			/* @ts-ignore */
			setImgName(file[0].name);
			/* @ts-ignore */
			setImgSize(file[0].size);
		}
	}, [file]);

	return (
		<div
			className={`input-file${file?.length !== 0 && file !== null  ? ' input-file--active' : ''}`}
		>
			<label htmlFor={inputName} className="form-label">
				{label} {required && '*'}
			</label>
			<div className="input-file__inner">
				<input
					{...register(inputName, rules)}
					type="file"
					id={inputName}
					className="input-file"
					accept="image/jpeg, image/png"
				/>
				<span>
					{ReactHtmlParser(placeholder, {
						transform: transformSource,
					})}
				</span>
				<div className="input-file__file-loaded loaded-file">
					<div
						className="loaded-file__img"
						style={{ backgroundImage: bgImg }}
					/>
					<div className="loaded-file__text">
						{imgName && <p className="loaded-file__name">{imgName}</p>}
						{imgSize && (
							<span className="loaded-file__size">{formatBytes(imgSize)}</span>
						)}
					</div>
					<div
						className="loaded-file__remove"
						/* @ts-ignore */
						onClick={() => reset()}
						/* @ts-ignore */
						onKeyPress={() => reset()}
						role="button"
						tabIndex={0}
					>
						<RemoveIcon />
					</div>
				</div>
			</div>
			<span className="form-guide">{bottomText}</span>
		</div>
	);
}

InputFile.defaultProps = {
	required: false,
	file: '',
};

export default InputFile;
